export const CustomerSiteValidation = (formData) => {
    const errors = {};
    if (!formData.BranchName || !formData.BranchName.trim()) {
        errors.BranchName = 'This field is required';
    }
    if (!formData.Forename || !formData.Forename.trim()) {
        errors.Forename = 'This field is required';
    }
    if (!formData.Surname || !formData.Surname.trim()) {
        errors.Surname = 'This field is required';
    }
    if (formData.Email) {
        if (!isValidEmail(formData.Email)) {
            errors.Email = 'Please enter a valid email address';
        }
    }
    return errors;
};
const isValidEmail = (email) => {
    // You can implement a regex or use a library like validator.js to validate email format
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
